import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

import { sensitiveAction } from '@repo/sca/domain/sensitive-action';
import { dropTask } from 'ember-concurrency';
import window from 'ember-window-mock';

import { jsURL } from 'register-partners-js/constants/hosts';
import { LoginPage } from 'register-partners-js/react/components/login-page';
import { ErrorInfo } from 'register-partners-js/utils/error-info';
import { createEmberZendeskLocalizationAdapter } from 'register-partners-js/utils/zendesk-localization-adapter';

export default class LoginController extends Controller {
  loginPage = LoginPage;

  @service intl;
  @service networkManager;
  @service userManager;
  @service zendeskLocalization;
  @service session;
  @service segment;
  @service sentry;

  get isSmallScreen() {
    return window.matchMedia?.('(max-width: 776px)').matches;
  }

  authenticateTask = dropTask(async (email, password) => {
    try {
      await sensitiveAction({
        action: async () => {
          if (!this.session.isAuthenticated && !email) {
            return;
          }
          if (!this.session.isAuthenticated) {
            await this.session.authenticate('authenticator:custom', { email, password });
          }
        },
        onScaSuccess: params => {
          this.networkManager.scaHeader = params;
        },
        hostFaqService: createEmberZendeskLocalizationAdapter(this.zendeskLocalization),
        user: this.userManager.currentUser || {},
      });
      this.segment.track('onboarding_partner_credential_method_selected', {
        authentication_method: 'email_pwd',
      });
    } catch (error) {
      let errorInfo = ErrorInfo.for(error);
      if (errorInfo.shouldSendToSentry) {
        this.sentry.captureException(error);
      }
      // Re-throw the error so the LoginForm component can handle it
      throw error;
    }
  });

  @action
  redirectForgotPassword() {
    window.location.href = `${jsURL}/passwords/forgot`;
  }
}
